<div class="viewport">
    <div class="strip" [style.transform]="isDetailVisible() ? 'translateX(-100%)' : 'translateX(0)'">
        <div class="slide">
            <spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">
                 <div actions>
                    <p-button (click)="onInsert()" icon="pi pi-plus" severity="primary" label="Nuovo" ></p-button>
                </div>
                <div header>
                    <spike-orders-filters-form [(searchFilter)]="searchFilter"></spike-orders-filters-form>
                </div>

                <div>
                    @if(entityList.hasValue() && entityList.value().list.length>0){
                        <div class="font-bold text-xl mb-1">Elenco risultati {{entityList.value().list.length}}</div>
                        <div class="spike-table-card">
                            <spike-orders-table 
                                [items]="entityList.value().list" 
                                [(sorting)]="sorting"
                                (onSelect)="onSelect($event)">
                            </spike-orders-table>
                            <p-paginator 
                                (onPageChange)="onPageChange($event)" 
                                [first]="pagination().first" 
                                [rows]="pagination().rows" 
                                [totalRecords]="entityList.value().totalCount" 
                                [rowsPerPageOptions]="this.pagination().rowsPerPageOptions" />
                        </div>
                    } @else {
                        <spike-no-result></spike-no-result>
                    }
                </div>

            </spike-base-page>
        </div>

        <div class="slide">
            @if(isDetailVisible()) {
                <spike-order-page 
                    [orderId]="selectedItem()?.orderId" 
                    (onSave)="onSave()"
                    (back)="isDetailVisible.set(false)">
                </spike-order-page>
            }
        </div>

    </div>
</div>
